<template>
    <div class="ownAchievement">
        <div class="content">
            <div class="title">统计周期</div>
            <van-radio-group v-model="formData" direction="horizontal" class="radioGroup" @change="getDate">
                <van-radio name="week">本周</van-radio>
                <van-radio name="month">本月</van-radio>
                <van-radio name="all">自定义</van-radio>
            </van-radio-group>
            <div class="dateAll" @click="changeDate" :class="dateAllClass">
                <span>{{ sDate | dateFormat("yyyy年MM月dd日") }}</span>
                <div>至</div>
                <span>{{ eDate | dateFormat("yyyy年MM月dd日") }}</span>
                <img src="@static/images/settlement/date.png" class="date">
            </div>
            <div class="line"></div>
            <div class="title">业绩合计</div>
            <div class="fee">
                <div class="flexClass">
                    <span class="num">{{ feeData.userNums || '0' }}</span>
                    <span class="unit">出单人数</span>
                </div>
                <div class="flexClass">
                    <span class="num">{{ feeData.policyNum }}</span>
                    <span class="unit">保/批单(件)</span>
                </div>
                <div class="flexClass">
                    <div>
                        <span class="num">{{ parseInt(feeData.totalFee) }}.</span>
                        <span class="number2">{{ getLastNum(feeData.totalFee) }}</span>
                    </div>
                    <span class="unit">保费(元)</span>
                </div>
                <div class="flexClass">
                    <div>
                        <span class="num">{{ parseInt(feeData.totalFyb) }}.</span>
                        <span class="number2">{{ getLastNum(feeData.totalFyb) }}</span>
                    </div>
                    <span class="unit">标保(元)</span>
                </div>
            </div>
            <div class="title" ref="listContent">业绩详情</div>
            <div class="none" :class="headerFixed ? 'positionFixed1' : ''"></div>
            <div class="list-main">
                <!-- 团队业绩 -->
                <van-tabs v-model="tabActive" @change="tabClick" :class="headerFixed ? 'positionFixed2' : ''">
                    <van-tab title="按成员查看" name="1"></van-tab>
                    <van-tab title="按职级查看" name="2"></van-tab>
                    <van-tab title="按产品分类查看" name="3"></van-tab>
                </van-tabs>
                <!-- 按成员查看 -->
                <van-list v-if="tabActive == '1'" :finished="finished">
                    <div class="detail-title" :class="headerFixed ? 'positionFixed' : ''">
                        <div>成员</div>
                        <div>件数</div>
                        <div @click="changeDes(1)">规模保费
                            <div class="icon">
                                <img src="@static/images/settlement/shangxin.png" alt="" v-if="descType == 2 && blueTrue"
                                    class="icon-one">
                                <img src="@static/images/settlement/xiaxin.png" alt="" v-else-if="descType == 1 && blueTrue"
                                    class="icon-one">
                                <img src="@static/images/settlement/hui.png" alt="" v-else class="icon-one">
                            </div>
                        </div>
                        <div @click="changeDes(0)">标准保费
                            <div class="icon">
                                <img src="@static/images/settlement/shangxin.png" alt="" v-if="descType == 2 && !blueTrue"
                                    class="icon-one">
                                <img src="@static/images/settlement/xiaxin.png" alt=""
                                    v-else-if="descType == 1 && !blueTrue" class="icon-one">
                                <img src="@static/images/settlement/hui.png" alt="" v-else class="icon-one">
                            </div>
                        </div>
                    </div>
                    <div class="detailContent" v-for="(item, index) in performanceList" :key="index">
                        <span>{{ item.agentName }}</span>
                        <span>{{ item.nums }}</span>
                        <span>{{ item.fee }}</span>
                        <span>{{ item.fyb }}</span>
                    </div>
                </van-list>
            </div>
            <!-- 按职级查看 -->
            <van-list v-if="tabActive == '2'" :finished="finished">
                <div class="detail-title2" :class="headerFixed ? 'positionFixed' : ''">
                    <div>职级</div>
                    <div>出单人数/件数</div>
                    <div @click="changeDes(1)">规模保费
                        <div class="icon">
                            <img src="@static/images/settlement/shangxin.png" alt="" v-if="descType == 2 && blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/xiaxin.png" alt="" v-else-if="descType == 1 && blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/hui.png" alt="" v-else class="icon-one">
                        </div>
                    </div>
                    <div @click="changeDes(0)">标准保费
                        <div class="icon">
                            <img src="@static/images/settlement/shangxin.png" alt="" v-if="descType == 2 && !blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/xiaxin.png" alt="" v-else-if="descType == 1 && !blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/hui.png" alt="" v-else class="icon-one">
                        </div>
                    </div>
                </div>
                <div class="detailContent2" v-for="(item, index) in performanceList" :key="index">
                    <span>{{ item.rankName }}</span>
                    <span>{{ item.userNums }}/{{ item.nums }}</span>
                    <span>{{ item.fee }}</span>
                    <span>{{ item.fyb }}</span>
                </div>
            </van-list>
            <!-- 按产品分类查看 -->
            <van-list v-if="tabActive == '3'" :finished="finished">
                <div class="detail-title2" :class="headerFixed ? 'positionFixed' : ''">
                    <div>产品分类</div>
                    <div>出单人数/件数</div>
                    <div @click="changeDes(1)">规模保费
                        <div class="icon">
                            <img src="@static/images/settlement/shangxin.png" alt="" v-if="descType == 2 && blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/xiaxin.png" alt="" v-else-if="descType == 1 && blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/hui.png" alt="" v-else class="icon-one">
                        </div>
                    </div>
                    <div @click="changeDes(0)">标准保费
                        <div class="icon">
                            <img src="@static/images/settlement/shangxin.png" alt="" v-if="descType == 2 && !blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/xiaxin.png" alt="" v-else-if="descType == 1 && !blueTrue"
                                class="icon-one">
                            <img src="@static/images/settlement/hui.png" alt="" v-else class="icon-one">
                        </div>
                    </div>
                </div>
                <div class="detailContent2" v-for="(item, index) in performanceList" :key="index">
                    <span>{{ item.productTypeName }}</span>
                    <span>{{ item.userNums }}/{{ item.nums }}</span>
                    <span>{{ item.fee }}</span>
                    <span>{{ item.fyb }}</span>
                </div>
            </van-list>
            <div class="null" v-if="performanceList.length == 0">
                <img class="null-img" src="@static/images/null.png" />
                <span class="null-text">暂无数据</span>
            </div>
        </div>
        <datePopup ref="datePanel" @submit="selectDate"></datePopup>
    </div>
</template>
  
<script>
import datePopup from "./showDatePopup.vue";
export default {
    components: { datePopup },
    data() {
        return {
            tabActive: '1',
            formData: 'month',
            descType: 1,
            blueTrue: true,
            dateAllClass: '',
            curDateIndex: 0,
            headerFixed: false,
            sDate: new Date(),
            eDate: new Date(),
            minDate: new Date(2010, 0, 1),
            maxDate: new Date(),
            astrictToday: true,
            currentDate: new Date(),
            dateShow: false,
            finished: true, //是否完成上拉加载
            feeData: {},
            performanceList: []
        }
    },
    mounted() {
        this.getDate()
        this.getFeeData()
        this.getTeamFeeData()
        sessionStorage.setItem('page', 1)
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const listContent = this.$refs.listContent;
            this.headerFixed = listContent.getBoundingClientRect().top < 0
        },
        changeDes(item) {
            if (item) {
                this.blueTrue = true
            } else {
                this.blueTrue = false
            }
            if (this.descType == 1) {
                this.descType = 2
            } else {
                this.descType = 1
            }
            this.getFeeData()
        },
        // 选择时间
        selectDate(date) {
            this.sDate = date[0];
            this.eDate = date[1];
            this.getTeamFeeData()
            this.getFeeData()
        },
        changeDate() {
            if (this.formData == 'all') {
                this.$refs.datePanel.open(this.sDate, this.eDate)
            }
        },
        tabClick() {
            this.getFeeData()
        },
        getLastNum(num) {
            return ("00" + ((num * 100).toFixed(2) % 100)).substr(-2);
        },
        submit() {
            this.getFeeData()
            this.getTeamFeeData()
            this.dateShow = false
        },
        getTeamFeeData() {
            this.loading = true;
            this.$http({
                type: "GET",
                url: "/api/userBase/groupStatistics",
                data: {
                    beginDate: this.$tools.dateFormat(this.sDate, "yyyy-MM-dd"),
                    endDate: this.$tools.dateFormat(this.eDate, "yyyy-MM-dd"),
                },
            })
                .then((res) => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 150);
                    this.feeData = res.data;
                })
                .catch((e) => {
                    console.log(e);
                    this.loading = false;
                });
        },
        getFeeData() {
        this.loading = true;
        this.$http({
            type: "GET",
            url: "/api/settlementUserDetail/getGroupResult",
            data: {
                beginDate:this.$tools.dateFormat(this.sDate,"yyyy-MM-dd"),
                endDate:this.$tools.dateFormat(this.eDate,"yyyy-MM-dd"),
                type:this.tabActive,
                descType:this.descType
            },
            apiPermissionCode:'APP_MY_LOOKUP_PERFORMANCE'
        })
        .then((res) => {
            setTimeout(() => {
                this.loading = false;
            }, 150);
            this.performanceList = res.data;
        })
        .catch((e) => {
            this.loading = false;
        });

        },
        getDate() {
            let date = new Date()
            if (this.formData == 'week') {
                let first = date.getDate() - (date.getDay() == 0 ? 6 : (date.getDay() - 1));
                this.sDate = new Date(date.setDate(first))
                this.eDate = new Date()
                this.dateAllClass = ''
            } else if (this.formData == 'month') {
                this.sDate = new Date(date.setDate(1));
                this.eDate = new Date()
                this.dateAllClass = ''
            } else if (this.formData == 'all') {
                this.dateAllClass = 'dateAllClass'
            }
            this.getFeeData()
            this.getTeamFeeData()
            this.dateShow = false
        },
        // 修改筛选时间
        dateChange() {
            if (this.curDateIndex == 0) {
                this.sDate = this.currentDate;
            } else {
                this.eDate = this.currentDate;
            }
        },
        // 开始结束时间点击
        timeClick(i) {
            this.curDateIndex = i;
            this.$nextTick((_) => {
                this.currentDate = i == 0 ? this.sDate : this.eDate;
            });
        },
    }
}
</script>
  
<style lang="scss" scoped>
@import"./teamAchievement.scss";
</style>